import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";
import { IAddSubject, ISubject } from "../../Subject.props";

const useAddSubject = () => {
  const [formData, setFormData] = useState<IAddSubject>({
    languageName: "",
    courseName: "",
    standard: "",
    subject: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [subject, setSubject] = useState<ISubject | null>(null);
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const [standard, setStandard] = useState<any[]>([]);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { id, value } = e.target;
    const files = (e.target as HTMLInputElement).files;

    if (id === "imageUrl" || id === "pdfUrl") {
      setFormData((prevState) => ({
        ...prevState,
        [id]: files ? files[0] : null,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };
  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [coursesResponse, languagesResponse,standardResponse ] =
        await Promise.all([
          ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
          ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
          ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
        ]);

      setCourses(coursesResponse);
      setLanguages(languagesResponse);
      setStandard(standardResponse);
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages."); // Show error toast
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit: SubmitHandler<IAddSubject> = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("languageName", formData.languageName);
      formDataToSend.append("courseName", formData.courseName);
      formDataToSend.append("standard", formData.standard);
      formDataToSend.append("subject", formData.subject);

      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createSubject}`,
        data: formDataToSend,
        // No need to set Content-Type manually when using FormData
      });
  
      if (response) {
        toast.success("Subject added successfully");
        navigate("/subject");
      }
    } catch (error) {
      toast.error("Error adding subject");
      console.error("Error adding subject:", error);
    }
  };

  const handleCancel = () => {
    navigate("/subject");
  };
  // Fetch data when the component mounts
  useEffect(() => {
    fetchCoursesAndLanguages(); // Fetch courses and languages
  }, []);

  return {
    loading,
    formData,
    subject,
    courses,
    languages,
    subjectName,
    standard,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddSubject;
